import {Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import {Router, NavigationEnd} from '@angular/router';
import {Idle, DEFAULT_INTERRUPTSOURCES} from '@ng-idle/core';
import {environment} from '../environments/environment';
import {AuthService} from './auth/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  isLoginBackground = false;
  timedOut = false;
  idleTime = environment.idleTime;

  constructor(private location: Location,
              private router: Router,
              private idle: Idle,
              private authService: AuthService) {

    // A los dos minutos se considera que el usuario esta ocioso
    idle.setIdle(this.idleTime);

    // Desloguar un poco antes
    idle.setTimeout(environment.tokenExpiration = this.idleTime);

    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => {
      // Todo: reset token
    });
    idle.onTimeout.subscribe(() => {
      this.authService.logout();
      this.router.navigate(['auth', 'login']);
    });

    this.reset();
  }

  ngOnInit() {
    this.router.events.filter(event => event instanceof NavigationEnd).subscribe(event => {
      this.isLoginBackground = this.location.path().indexOf('login') > -1;
    });
  }

  private reset() {
    this.idle.watch();
    this.timedOut = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts